import {ActionTree} from "vuex";
import axios from 'axios';
import {ReportFilter, ReportsState} from "@/store/reports/types";
import {RootState} from "@/store/types";
import {directDownload, transformTransport} from "@/utils/download-helper";

export const actions: ActionTree<ReportsState, RootState> = {
  getReports: ({commit, dispatch}, data: ReportFilter) => {
    return new Promise(async (resolve, reject) => {
      try {
        let resp = await axios({url: '/stats-api/reports', params: data})
        commit('setReports', resp.data.reports);
        resolve(resp)
      } catch (err) {
        reject(err)
      }
    })
  },
  downloadReport: ({commit, dispatch}, id: number) => {
    return directDownload(`/stats-api/reports/${id}/download` )
  },
  getSummaryGroup: ({commit, dispatch}, data: ReportFilter) => {
    return new Promise(async (resolve, reject) => {
      try {
        let resp = await axios({url: '/stats-api/group/summary', params: data})
        let messages = []
        let messages_summary = {}
        if (resp.data.messages_summary) {
          let total = {}
          resp.data.messages_summary.forEach((element:any) => {
            //@ts-ignore
            total[element.transport_name] = 0
            //@ts-ignore
            messages_summary[element.transport_name] = element.messages_count
          })
          messages = resp.data.messages.map((item:any) => {
            let row = Object.assign({}, {date: item.date}, total)
            if (item.messages_data.length > 0) {
              item.messages_data.forEach((transport: any) => {
                //@ts-ignore
                return row[transport.transport_name] = transport.messages_count
              });
            }
            return row
          })
        }
        commit('setSummaryGroup', {messages, messages_summary});
        resolve(resp)
      } catch (err) {
        reject(err)
      }
    })
  },
  exportSummaryStatisticGroup: ({commit, dispatch}, data: ReportFilter) => {
    return new Promise(async (resolve, reject) => {
      try {
        let resp = await axios({url: '/stats-api/group/summary/export', params: data})
        resolve(resp)
      } catch (err) {
        reject(err)
      }
    })
  },
  removeReport: ({commit, dispatch}, id: number) => {
    return new Promise(async (resolve, reject) => {
      try {
        let resp = await axios({
          method: 'DELETE',
          url: '/stats-api/reports/'+id,
        })
        resolve(resp)
      } catch (err) {
        reject(err)
      }
    })
  },
  getReportAdditionalInfo: ({commit, dispatch}, id: number) => {
    return new Promise(async (resolve, reject) => {
      try {
        let resp = await axios({url: `/stats-api/reports/${id}/additional_info`})
        resolve(resp?.data?.contacts_check_info)
      } catch (err) {
        reject(err)
      }
    })
  },
  async getStatisticGroup({commit, dispatch}, {transport, filter}) {
    try {
      const resp = await axios({
        url: '/stats-api/group/' + transformTransport(transport),
        params: filter,
      })
      return resp;
    } catch(err) {
      throw err;
    }
  },
}